// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { View } from 'reshaped';

import { withPageMeta } from '@gandi/app-runner';

import { updateCart, getCart, selectCartUUID } from '@gandi/cart';
import { notifyDanger } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';

import { ContactForm } from 'src/Cart/ContactForm';
import { Layout } from 'src/components/Layout';
import { useAppSelector } from 'src/hooks';
import { selectShopCurrent } from 'src/modules/organization/selectors';

import { StudioAccountHeader } from './Header';

function StudioAccount(): React.MixedElement {
  const { __ } = useTranslator();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartId = useAppSelector(selectCartUUID);
  const current = useAppSelector(selectShopCurrent);

  React.useEffect(() => {
    if (!current || !current?.phone) return;
    const orgId = current.id;
    const run = async () => {
      try {
        await dispatch(
          updateCart(
            cartId,
            { owner_uuid: orgId, has_orga: true },
            { headers: { 'X-Dry-Run': '0' } },
          ),
        );
        await dispatch(getCart());
        navigate(`/cart/${cartId}/overview`);
      } catch (err) {
        dispatch(notifyDanger(__('Unexpected error occurred')));
      }
    };

    run();
  }, [__, cartId, current, current?.id, current?.phone, dispatch, navigate]);

  return (
    <Layout showCartSummary>
      <View gap={7}>
        <View.Item>
          <StudioAccountHeader />
        </View.Item>
        <View.Item>
          <ContactForm contact={current} studio />
        </View.Item>
      </View>
    </Layout>
  );
}

export default (withPageMeta(({ __ }) => ({
  title: __('Gandi studio - Gandi.net'),
  description: __(
    'Last step before check-out : add your phone number to complete your order with gandi.studio quick and easy.',
  ),
}))(StudioAccount): React.ComponentType<{}>);
